import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  constructor(private readonly _toastrService: ToastrService) {}

  public showSuccessMessage(message: string): void {
    this._toastrService.success(message, 'Success', {
      closeButton: true,
      disableTimeOut: true,
    });
  }

  public showErrorMessage(message: string): void {
    this._toastrService.error(message, 'Error', {
      closeButton: true,
      disableTimeOut: true,
    });
  }

  public showInfoMessage(message: string): void {
    this._toastrService.info(message, 'Info', {
      closeButton: true,
      disableTimeOut: true,
    });
  }

  public customMessage(message: string, title: string, timeOut: number): void {
    this._toastrService.info(message, title, {
      timeOut: timeOut,
      progressBar: true,
    });
  }

  public removeAllNotifications(): void {
    this._toastrService.clear();
  }
}
